module.exports = __webpack_public_path__ + "img/m-banner-csrrksao-pt-PT.e8eaf239.jpg";